// extracted by mini-css-extract-plugin
export var errorsContainer = "_r3-1";
export var link = "_r3-0";